<template>

    <div class="table">
        <table>

            <tr>
                <th class="th-first">Description</th>
                <th class="th-center">Price</th>
                <th class="th-center">Quantity</th>
                <th class="th-end">Discount</th>
            </tr>

            <tr v-for="item in value" :key="item.name">
                <td class="td-first">{{item.name}}</td>
                <td class="td-center">$ {{item.price}}</td>
                <td class="td-center">{{item.quantity}}</td>
                <td class="td-end">$ {{item.discount}}</td>
            </tr>

        </table>
    </div>

</template>


<script>
    export default {
        props: {
            value : {Array,Object,required:true}
        }

    }
</script>

<style scoped>
    .td-center {
        text-align: center;
    }

    .table {
        margin-bottom: 90px;
    }

    th {
        color: rgb(70, 60, 60);
        border-bottom: 1px solid rgba(70, 60, 60, 0.39);
        font-weight: bold;
        font-size: 10px;
        height: 30px;
        padding-bottom: 3px;

    }

    td {
        padding-top: 20px;
        font-weight: bold;
        font-size: 11px;

    }

    .td-first {
        text-align: left;
    }


    .td-end {
        color: rgb(230, 40, 15);
        text-align: right;
    }


    table {
        width: 100%;
        border-collapse: collapse;

    }

    .th-first {
        text-align: left;
    }

    .th-end {
        text-align: end;
    }

    .td-by {
        font-size: 18px;
    }


</style>